/* eslint-disable */
import React, { ReactNode, useEffect } from "react";
import styles from "./StatisticsManagementIndex.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  createStyles,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  withStyles,
} from "@material-ui/core";
import PuiTypography from "../../../components/elements/PuiTypography";
import { format } from "date-fns";
import DownloadIcon from "../../../assets/icon/DownloadIcon";
import { Line, Doughnut } from "react-chartjs-2";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  LoadPopularRanking,
  LoadStatistics,
} from "../../../store/actions/ExVideoActions";
import { AppState } from "../../../root/RootReducer";
import { PopularTagList, PopularVideoList } from "../../../models/statistics";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
  Align,
} from "chart.js";
import ChartDataLabels, { Context }  from "chartjs-plugin-datalabels";
import { Margin } from "@mui/icons-material";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
  ChartDataLabels
);

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={styles.graphContainer}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

interface StatisticsTabsProps {
  value: number;
  className: string;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  children?: React.ReactNode;
}

const StatisticsTabs = withStyles({
  root: {
    border: "1px solid var(--gray-61)",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
    },
  },
})((props: StatisticsTabsProps) => (
  <Tabs
    {...props}
    variant="fullWidth"
    scrollButtons="off"
    textColor="secondary"
    TabIndicatorProps={{ children: <span /> }}
  >
    {props.children}
  </Tabs>
));

interface StatisticsTabProps {
  label: ReactNode;
}

const StatisticsTab = withStyles(() =>
  createStyles({
    root: {
      textTransform: "none",
      minWidth: 50,
      border: "1px solid var(--gray-61)",
      backgroundColor: "rgba(237, 237, 237, 1)",
      "&:hover": {
        backgroundColor: "rgba(237, 237, 237, 0.6)",
      },
      "&$selected": {
        backgroundColor: "var(--white)",
      },
      "&:focus": {
        backgroundColor: "var(--white)",
      },
    },
    selected: {},
  })
)((props: StatisticsTabProps) => <Tab disableRipple {...props} />);

const DateTextField = withStyles({
  root: {
    "& .MuiInput-underline:after": {
      borderBottomColor: "var(--black)",
    },
  },
})(TextField);

const useStyles = makeStyles(() =>
  createStyles({
    dateField: {
      width: "170px",
      margin: "0 10px",
    },
  })
);

export default function StatisticsManagementIndex() {
  const dispatch = useDispatch();
  const classes = useStyles();

  // パラメータ初期化
  const [startDate, setStartDate] = React.useState<string>(
    format(new Date().setDate(1), "yyyy-MM-dd")
  );
  const [endDate, setEndDate] = React.useState<string>(
    format(new Date(), "yyyy-MM-dd")
  );
  const [tabIndex, setTabIndex] = React.useState<number>(0);
  const [viewCountList, setViewCountList] = React.useState<number[]>([]);
  const [playTimeList, setPlayTimeList] = React.useState<number[]>([]);
  const [userCountList, setUserCountList] = React.useState<number[]>([]);
  const [viewCountLabel, setViewCountLabel] = React.useState<string[]>([]);
  const [playTimeLabel, setPlayTimeLabel] = React.useState<string[]>([]);
  const [userCountLabel, setUserCountLabel] = React.useState<string[]>([]);
  const [rankGraphData, setRankGraphData] = React.useState<number[]>([]);
  const [rankGraphLabel, setRankGraphLabel] = React.useState<string[]>([]);

  // プロジェクトパラメータ
  const { stats, ranking, isLoading } = useSelector((state: AppState) => ({
    stats: state.exVideo.statistics.stats,
    ranking: state.exVideo.statistics.ranking,
    isLoading: state.exVideo.contextPhrase.isLoading,
  }));

  // 統計情報・人気ランキング情報取得
  useEffect(() => {
    dispatch(LoadStatistics(startDate, endDate));
    dispatch(LoadPopularRanking(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    // 視聴回数
    let datas: number[] = [];
    let labels: string[] = [];
    stats.viewCountList.map((item) => {
      datas.push(item.statisticsCount);
      labels.push(String(item.statisticsDate).replaceAll("-", "/"));
      return null;
    });
    setViewCountList(datas);
    setViewCountLabel(labels);
    // 視聴時間
    datas = [];
    labels = [];
    stats.playTimeList.map((item) => {
      datas.push(
        Math.round((item.statisticsCount / 3600000) * 100) / 100 === 0 &&
          item.statisticsCount > 0
          ? 0.01
          : Math.round((item.statisticsCount / 3600000) * 100) / 100
      );
      labels.push(String(item.statisticsDate).replaceAll("-", "/"));
      return null;
    });
    setPlayTimeList(datas);
    setPlayTimeLabel(labels);
    // 視聴人数
    datas = [];
    labels = [];
    stats.userCountList.map((item) => {
      datas.push(item.statisticsCount);
      labels.push(String(item.statisticsDate).replaceAll("-", "/"));
      return null;
    });
    setUserCountList(datas);
    setUserCountLabel(labels);
    // 人気ランキング
    let doughnutDataList: number[] = [];
    let doughnutLabelList: string[] = [];
    ranking.popularPeriodList.map((item) => {
      doughnutDataList.push(item.count);
      doughnutLabelList.push(item.period);
      return null;
    });
    setRankGraphData(doughnutDataList);
    setRankGraphLabel(doughnutLabelList);
  }, [stats, ranking]);

  // タブ切り替え
  const handleChangeTab = (event: React.ChangeEvent<{}>, index: number) => {
    setTabIndex(index);
  };

  // 検索期間（開始日）変更
  const handleChangeStartDate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setStartDate(event.target.value.replaceAll("/", "-"));
  };

  // 検索期間（終了日）変更
  const handleChangeEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(event.target.value.replaceAll("/", "-"));
  };

  const viewCountData = {
    labels: viewCountLabel,
    datasets: [
      {
        label: "count",
        data: viewCountList,
        fill: true,
        backgroundColor: "rgba(255, 0, 0, 0.1)",
        borderColor: "rgba(255, 0, 0, 0.4)",
      },
    ],
  };

  const playTimeData = {
    labels: playTimeLabel,
    datasets: [
      {
        label: "count",
        data: playTimeList,
        fill: true,
        backgroundColor: "rgba(0, 255, 0, 0.1)",
        borderColor: "rgba(0, 255, 0, 0.4)",
      },
    ],
  };

  const userCountData = {
    labels: userCountLabel,
    datasets: [
      {
        label: "count",
        data: userCountList,
        fill: true,
        backgroundColor: "rgba(0, 0, 255, 0.1)",
        borderColor: "rgba(0, 0, 255, 0.4)",
      },
    ],
  };

  var delayed: boolean;
  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        stacked: true,
      },
      x: {
        stacked: true,
      },
    },
    plugins: {
      legend: { display: false },
    },
    animation: {
      onComplete: () => {
        delayed = true;
      },
      delay: (context: any) => {
        let delay = 0;
        if (context.type === "data" && context.mode === "default" && !delayed) {
          delay = context.dataIndex * 200 + context.datasetIndex * 100;
        }
        return delay;
      },
    },
  };

  const timeRankingData = {
    labels: rankGraphLabel,
    datasets: [
      {
        label: "count",
        data: rankGraphData,
        backgroundColor: [
          "rgba(174, 44, 72, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 0,
        datalabels: {
          labels: {
            name: {
              align: "start" as Align,
              font: { size: 14, weight: "bold" as const },
              formatter: (value: any, ctx: any) => {
                // 直接返回标签，不要加空格换行
                return ctx.chart.data.labels[ctx.dataIndex];
              },
              padding: 2,
            },
            value: {
              align: "end" as Align,
              font: { size: 12, weight: "bold" as const },
              backgroundColor: "white",
              borderColor: "lightgray",
              borderWidth: 1,
              borderRadius: 6,
              color: (ctx: any) => ctx.dataset.borderColor[ctx.dataIndex],
              formatter: (value: any, ctx: any) => {
                const total = rankGraphData.reduce((sum, item) => sum + Number(item), 0);
                const percentage = ((value / total) * 100).toFixed(1); // 保留一位小数
                return `${value}回\n${percentage}%`;
              },
              padding: 4,
              offset: 6, // 用 offset 而不是 Margin
            },
          },
        },
      },
    ],
  };
  

    const timeRankinOptions = {
      cutout: "1%",
      plugins: {
        datalabels: {
          align: "end" as const,
          formatter: (value: number, ctx: any) => {
            const data = ctx.chart.data.datasets[0].data as number[];
            const total = data.reduce((sum, val) => sum + val, 0);
            const percentage = total ? ((value / total) * 100).toFixed(1) + "%" : "0%";
            // 统一显示「次数 + 百分比」
            return `\n\n\n\n\n\n　　　　${value}回\n\n\n\n\n${percentage}　　　\n\n\n`;
          },
          anchor: (ctx: any) => {
            const data = ctx.chart.data.datasets[0].data as number[];
            const total = data.reduce((sum, val) => sum + val, 0);
            const value = data[ctx.dataIndex];
            const percent = (value / total) * 100;
            return "center" as const; // 小于10%移到外侧
          },
        },
        tooltip: { enabled: false },
      },
      legend: {
        position: "left", // 图例移到右边
        labels: {
          font: { size: 14 },
        },
      },
      animation: false
    };

  // 表示待機
  if (isLoading) {
    return (
      <div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.conditionArea}>
        <div className={styles.conditions}>
          <PuiTypography size={20} bold={true}>
            期間
          </PuiTypography>
          <DateTextField
            id="startDate"
            type="date"
            defaultValue={startDate}
            className={classes.dateField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeStartDate}
          />
          ～
          <DateTextField
            id="endDate"
            type="date"
            defaultValue={endDate}
            className={classes.dateField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeEndDate}
          />
        </div>
        <a
          href={
            "/api/exportStatistics?startDate=" +
            startDate +
            "&endDate=" +
            endDate
          }
          download
          className={styles.downloadLink}
        >
          <DownloadIcon size={18} />
          <PuiTypography size={20} bold={true}>
            CSVダウンロード
          </PuiTypography>
        </a>
      </div>
      <div className={styles.graphArea}>
        <StatisticsTabs
          value={tabIndex}
          onChange={handleChangeTab}
          className={styles.statisticstabs}
          aria-label="Statistics Tabs"
        >
          <StatisticsTab
            label={
              <PuiTypography size={20} bold={tabIndex === 0 ? true : false}>
                視聴回数
                <br />
                {`${viewCountList.reduce(
                  (sum, item) => sum + Number(item),
                  0
                )}回`}
              </PuiTypography>
            }
            {...a11yProps(0)}
          />
          <StatisticsTab
            label={
              <PuiTypography size={20} bold={tabIndex === 1 ? true : false}>
                総再生時間
                <br />
                {`${
                  playTimeList.reduce(
                    (sum, item) => Math.round(Number(sum) + Number(item) * 100),
                    0
                  ) / 100
                }時間`}
              </PuiTypography>
            }
            {...a11yProps(1)}
          />
          <StatisticsTab
            label={
              <PuiTypography size={20} bold={tabIndex === 2 ? true : false}>
                視聴者数(ユニーク)
                <br />
                {`${userCountList.reduce(
                  (sum, item) => sum + Number(item),
                  0
                )}人`}
              </PuiTypography>
            }
            {...a11yProps(1)}
          />
        </StatisticsTabs>

        <TabPanel value={tabIndex} index={0}>
          <Line data={viewCountData} height={300} options={lineOptions} />
        </TabPanel>

        <TabPanel value={tabIndex} index={1}>
          <Line data={playTimeData} height={300} options={lineOptions} />
        </TabPanel>

        <TabPanel value={tabIndex} index={2}>
          <Line data={userCountData} height={300} options={lineOptions} />
        </TabPanel>
      </div>

      <div className={styles.rankingArea}>
        <div className={styles.popularVideoArea}>
          <PuiTypography size={20} bold={true}>
            人気のVideo
          </PuiTypography>
          <div className={styles.popularVideoList}>
            {ranking.popularVideoList
              .slice(0, 10)
              .map((video: PopularVideoList) => (
                <div className={styles.popularVideo}>
                  <img
                    src={video.imageUrl}
                    className={styles.popularVideoImg}
                    alt={video.title}
                  />
                  <div className={styles.popularVideoTitle}>
                    <PuiTypography size={14} bold={true}>
                      {video.title}
                    </PuiTypography>
                  </div>
                  <div className={styles.popularVideoCount}>
                    <PuiTypography size={14} bold={true}>
                      {`${video.count}回`}
                    </PuiTypography>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className={styles.popularTagArea}>
          <PuiTypography size={20} bold={true}>
            人気のTag
          </PuiTypography>
          <div className={styles.popularTagList}>
            {ranking.popularTagList
              .slice(0, 10)
              .map((video: PopularTagList) => (
                <div className={styles.popularTag}>
                  <div className={styles.popularTagName}>
                    <PuiTypography size={14} bold={true}>
                      {video.tagName}
                    </PuiTypography>
                  </div>
                  <div className={styles.popularTagCount}>
                    <PuiTypography size={14} bold={true}>
                      {`${video.count}回`}
                    </PuiTypography>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className={styles.popularTimeArea}>
          <PuiTypography size={20} bold={true}>
            よく視聴される時間帯
          </PuiTypography>
          <Doughnut
            data={timeRankingData}
            // plugins={[ChartDataLabels]} ビルドエラー解決できないから、一旦ここでコメントアウト
            options={timeRankinOptions}
          />
        </div>
      </div>
    </div>
  );
}
